import { isInteger, last, split, toNumber } from 'lodash';

export const isArrayPrefix = (prefix: string) => {
  const parts = split(prefix, '.').filter((part) => part !== '');
  const lastPart = last(parts);
  return isInteger(toNumber(lastPart));
};
